var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _vm.canSeeTable
        ? _c("v-data-table", {
            staticClass: "elevation-1",
            class: {
              "select-all-disabled ": !_vm.hasPermissionToEdit,
              "no-show-permission": !_vm.selectable
            },
            attrs: {
              headers: _vm.headers,
              items: _vm.companies,
              search: _vm.searchFromParent,
              page: _vm.pagination.page,
              "items-per-page": _vm.paginationAssociatedCompanies.rowsPerPage,
              "show-select": _vm.selectable,
              loading: _vm.loading,
              "loading-text": "",
              "items-per-page-text": _vm.rowsPerPageText,
              "items-per-page-items": _vm.rowsPerPageItems,
              "header-props": { sortIcon: _vm.sortIcon },
              "footer-props": {
                prevIcon: _vm.prevIcon,
                nextIcon: _vm.nextIcon,
                "items-per-page-options": _vm.rowsPerPageItems
              }
            },
            on: {
              "update:page": function($event) {
                return _vm.$set(_vm.pagination, "page", $event)
              },
              "update:itemsPerPage": function($event) {
                return _vm.$set(
                  _vm.paginationAssociatedCompanies,
                  "rowsPerPage",
                  $event
                )
              },
              "update:items-per-page": function($event) {
                return _vm.$set(
                  _vm.paginationAssociatedCompanies,
                  "rowsPerPage",
                  $event
                )
              },
              "toggle-select-all": _vm.selectAll,
              pagination: function($event) {
                return _vm.setRowsOnLocalStorage(
                  _vm.dataTableAssociatedCompaniesId,
                  _vm.paginationAssociatedCompanies.rowsPerPage
                )
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "item",
                  fn: function(props) {
                    return [
                      _c(
                        "tr",
                        {
                          on: {
                            click: function($event) {
                              return _vm.viewItem(props.item)
                            }
                          }
                        },
                        [
                          _vm.selectable
                            ? _c(
                                "td",
                                { staticClass: "tableCheckbox" },
                                [
                                  _c("v-checkbox", {
                                    attrs: {
                                      "input-value": _vm.companySelected(
                                        props.item.uuid
                                      ),
                                      color: "accent",
                                      "hide-details": "",
                                      ripple: false,
                                      disabled: !_vm.hasPermissionToEdit
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.toggleCheckbox(props.item)
                                      },
                                      click: function($event) {
                                        $event.stopPropagation()
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "data-table-name" },
                            [
                              _c(
                                "v-layout",
                                { attrs: { row: "", "align-center": "" } },
                                [
                                  _c("img", {
                                    staticClass: "avatar data-table-logo",
                                    attrs: { src: props.item.image }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "data-table-name data-table-td-content"
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(props.item.name) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(props.item.email))]),
                          _vm._v(" "),
                          _c(
                            "td",
                            [
                              _vm.isActive(props.item.status)
                                ? _c(
                                    "v-layout",
                                    { attrs: { row: "", "align-center": "" } },
                                    [
                                      _c("div", {
                                        staticClass: "company-status-icon mr-3"
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "text-transform": "lowercase"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(_vm.$t("Active")) +
                                              "\n            "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _c(
                                    "v-layout",
                                    { attrs: { row: "", "align-center": "" } },
                                    [
                                      _c("div", {
                                        staticClass:
                                          "company-status-icon status-inactive mr-3"
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "text-transform": "lowercase"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(_vm.$t("Inactive")) +
                                              "\n            "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                            ],
                            1
                          )
                        ]
                      )
                    ]
                  }
                },
                {
                  key: "pageText",
                  fn: function(props) {
                    return [
                      _vm._v(
                        "\n      " +
                          _vm._s(props.pageStart) +
                          " - " +
                          _vm._s(props.pageStop) +
                          " " +
                          _vm._s(_vm.$t("tables.Of")) +
                          "\n      " +
                          _vm._s(props.itemsLength) +
                          "\n    "
                      )
                    ]
                  }
                },
                {
                  key: "no-results",
                  fn: function() {
                    return [
                      _c("data-table-no-results", {
                        attrs: { search: _vm.searchFromParent }
                      })
                    ]
                  },
                  proxy: true
                },
                {
                  key: "no-data",
                  fn: function() {
                    return [
                      _vm.loading
                        ? _c("div")
                        : _c(
                            "v-alert",
                            {
                              staticClass: "data-table-no-data",
                              attrs: { icon: "warning" }
                            },
                            [
                              _vm._v(
                                "\n        " +
                                  _vm._s(_vm.$t("NoDataCompanies")) +
                                  "\n      "
                              )
                            ]
                          )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              1118728400
            ),
            model: {
              value: _vm.selectedCompanies,
              callback: function($$v) {
                _vm.selectedCompanies = $$v
              },
              expression: "selectedCompanies"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.canSeeTable
        ? _c(
            "div",
            { class: { "page-section": !_vm.selectable } },
            [_c("app-no-permission-warning")],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a5db772e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5db772e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SystemManagement/Accounts/AssociatedCompanies.vue
// module id = null
// module chunks = 